export default __webpack_public_path__ + "static/ampm@1x-2559e47ff2648d1ee8f96cd2919b0010.webp";